enum AdminAnnouncementIconEnum {
    INFO = 'info-circle',
    CHECK = 'check-circle',
    OCTOBRE_ROSE = 'octobre-rose',
}

export default AdminAnnouncementIconEnum;
